import { render } from "./wastageProfitReport.vue?vue&type=template&id=9fe77efc&scoped=true"
import script from "./wastageProfitReport.vue?vue&type=script&lang=js"
export * from "./wastageProfitReport.vue?vue&type=script&lang=js"

import "./wastageProfitReport.vue?vue&type=style&index=0&id=9fe77efc&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9fe77efc"]])

export default __exports__